import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";

const Cell = ({ label, value, align = "left" }) => (
  <Box sx={{ textAlign: align }}>
    <Typography
      variant="caption"
      sx={{ display: "block", fontWeight: 600, color: "text.secondary" }}
    >
      {label}
    </Typography>
    <Typography variant="body2">{value}</Typography>
  </Box>
);

export default function Transaction({ trans }) {
  return (
    <Paper
      variant="outlined"
      sx={{ p: 2, mb: 2, borderLeft: 4, borderLeftColor: "primary.main" }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, sm: 6 }}>
          <Cell label="Item / Test" value={trans.Description} />
        </Grid>
        <Grid size={{ xs: 4, sm: 2 }}>
          <Cell label="Quantity" value={trans.Quantity} align="right" />
        </Grid>
        <Grid size={{ xs: 4, sm: 2 }}>
          <Cell label="Unit Cost" value={`$${trans.UnitPrice}`} align="right" />
        </Grid>
        <Grid size={{ xs: 4, sm: 2 }}>
          <Cell label="Line Total" value={`$${trans.ListPrice}`} align="right" />
        </Grid>
      </Grid>
    </Paper>
  );
}
